"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Reset all filters': 'Reset all filters'
        }
    },
    'es': {
        'translation': {
            'Reset all filters': 'Reinicializar los filtros'
        }
    },
};
//# sourceMappingURL=translations.js.map